import React, { useState } from 'react';
import Form from '../../coreComponents/Form/Form.tsx';
import './CreateDriver.css'; // Import your CSS file
import { useNavigate } from "react-router-dom";
import { createDriver } from '../../services/DriverService.ts';
import { Snackbar, Alert } from '@mui/material';

interface DriverData {
    phone: string;
}

const CreateDriver: React.FC = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
        open: false,
        message: '',
        severity: 'success'
    });

    const initialValues: DriverData = {
        phone: '',
    };

    const handleSubmit = async (data: DriverData) => {
        try {
            const response = await createDriver({...data, phone: `+91${data.phone.trim()}`});
            if (response.data) {
                setSnackbar({
                    open: true,
                    message: 'Driver created successfully',
                    severity: 'success'
                });
                // Navigate after a short delay to show the success message
                setTimeout(() => {
                    navigate("/driver-verification");
                }, 1500);
            }
        } catch (err: any) {
            if (err.response && err.response.status === 401) {
                console.error('Unauthorized access. Redirecting to login...');
                navigate('/login');
            } else if (err.response?.data?.detail?.includes('already exists')) {
                setSnackbar({
                    open: true,
                    message: 'Driver already registered',
                    severity: 'error'
                });
            } else {
                setError('Failed to create driver');
                setSnackbar({
                    open: true,
                    message: 'Failed to create driver',
                    severity: 'error'
                });
            }
            console.log(err);
        }
    };

    const handleCancel = () => {
        navigate("/driver-verification");
    };

    const fields = [
        { type: 'tel', name: 'phone', label: 'Phone', required: true }
    ];

    const buttons = [
        {
            id: 'submit-button',
            children: 'Submit',
            type: 'submit' as 'submit',
            variant: 'contained' as 'contained',
            fullWidth: false,
        },
        {
            id: 'cancel-button',
            children: 'Cancel',
            type: 'button' as 'button',
            variant: 'contained' as 'contained',
            fullWidth: false,
        },
    ];

    return (
        <div className="scrollable-form">
            <h1>Create Driver</h1>
            <Form
                fields={fields}
                initialValues={initialValues}
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                buttons={buttons}
            />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert 
                    onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} 
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default CreateDriver;
